var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandHortColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 168 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F60CE",
    fillRule: "evenodd",
    d: "M0 21.492h39.108V2.075H-.001v19.417Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#05E3AB",
    fillRule: "evenodd",
    d: "M0 34.397h29.33V21.492H0v12.905Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#23489B",
    fillRule: "evenodd",
    d: "M0 21.492h19.615V2.075H-.001v19.417Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#04AA80",
    fillRule: "evenodd",
    d: "M0 40.909h19.615V21.492H-.001v19.417Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F60CE",
    fillRule: "evenodd",
    d: "M86.813 21.482V2.065h29.331c5.4 0 9.777 4.333 9.777 9.678v.061c0 5.345-4.377 9.679-9.777 9.678h-29.33Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#05E3AB",
    fillRule: "evenodd",
    d: "m126.166 40.886-19.738-19.387-19.615 19.387h39.353Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#23489B",
    fillRule: "evenodd",
    d: "M86.813 21.498h19.616V2.08H86.813v19.418Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#04AA80",
    fillRule: "evenodd",
    d: "M86.813 40.885h19.615V21.468H86.813v19.417Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#23489B",
    fillRule: "evenodd",
    d: "M128.617 40.9V1.944l19.676 19.478L128.617 40.9Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#05E3AB",
    fillRule: "evenodd",
    d: "M128.617 40.9h39.352V1.944L128.617 40.9Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F60CE",
    fillRule: "evenodd",
    d: "M148.293 21.422 167.969 40.9h-39.352l19.676-19.478ZM78.094 6.44a21.034 21.034 0 0 1 0 29.96c-8.358 8.274-21.909 8.274-30.267 0a21.034 21.034 0 0 1 0-29.96c8.358-8.274 21.909-8.274 30.267 0Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#05E3AB",
    fillRule: "evenodd",
    d: "M41.51 21.409c0 11.714 9.592 21.21 21.425 21.21 11.834 0 21.427-9.496 21.427-21.21",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#23489B",
    fillRule: "evenodd",
    d: "M62.985 21.444V.234C51.152.234 41.56 9.73 41.56 21.444h21.426Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#04AA80",
    fillRule: "evenodd",
    d: "M62.985 21.409H41.559c0 11.714 9.593 21.21 21.426 21.21v-21.21Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandHortColour);
export default __webpack_public_path__ + "static/media/brand-hort-colour.bbaf66a3.svg";
export { ForwardRef as ReactComponent };